import React, { useState, useEffect } from "react";
import SimpleConfirmation from "./SimpleConfirmation";

const CategorySelector = ({ onClose, onSelect }) => {
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const [context, setContext] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  useEffect(() => {
    fetch(`${baseUrl}/php/fetch_categories.php`)
      .then((response) => response.json())
      .then((data) => setCategories(data.categories))
      .catch((error) => console.error("Error fetching categories:", error));
  }, []);

  function toTitleCase(inputString) {
    return inputString.replace(
      /\w\S*/g,
      (word) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
    );
  }

  const handleCategoryChange = (event) => {
    const categoryId = event.target.value;
    setSelectedCategory(categoryId);
    setSubcategories([]);
    setSelectedSubcategory("");

    if (categoryId) {
      fetch(`${baseUrl}/php/fetch_categories.php?category_id=${categoryId}`)
        .then((response) => response.json())
        .then((data) => setSubcategories(data.subcategories))
        .catch((error) =>
          console.error("Error fetching subcategories:", error)
        );
    }
  };

  const handleSubcategoryChange = (event) => {
    setSelectedSubcategory(event.target.value);
  };

  const handleSave = () => {
    const nonEnglishRegex =
      /[^\x20-\x7E\u00A0-\u00FF\u0100-\u017F\u2000-\u200B\u2010-\u201F\u2022\u2026\u2100-\u214F\u2190-\u21FF\u2200-\u22FF\u2300-\u23FF\u25A0-\u25FF\u20AC\u00A3\u00A5\u2122\u00AE\u00A9]/;
    if (context) {
      // Check the entire pasted content
      if (nonEnglishRegex.test(context)) {
        setShowDialog(true);
        return;
      }
    }
    onSelect({
      category: selectedCategory,
      subcategory: selectedSubcategory,
      context: toTitleCase(context),
    });
  };

  return (
    <>
      
      <SimpleConfirmation
        show={showDialog}
        onConfirm={() => setShowDialog(false)}
      />
      {" "}
      <div id="set_category_window" className="category_popup">
        <span className="closeLink" onClick={onClose}>
          &times;
        </span>
        <br />
        <input
          type="text"
          placeholder="Context In Brief"
          id="context"
          className="fullTextbox"
          autoComplete="off"
          maxLength="50"
          value={context}
          onChange={(e) => setContext(e.target.value)}
        />
        <select
          className="fullTextbox"
          id="categoryDropdown"
          value={selectedCategory}
          onChange={handleCategoryChange}
        >
          <option value="">Select Category</option>
          {categories.map((category) => (
            <option key={category.category_id} value={category.category_id}>
              {category.category_name}
            </option>
          ))}
        </select>
        <br />

        <select
          className="fullTextbox"
          id="subcategoryDropdown"
          value={selectedSubcategory}
          onChange={handleSubcategoryChange}
          disabled={!selectedCategory}
        >
          <option value="">Select Subcategory</option>
          {subcategories.map((subcategory) => (
            <option
              key={subcategory.category_id}
              value={subcategory.category_id}
            >
              {subcategory.category_name}
            </option>
          ))}
        </select>
        <br />

        <button
          style={{ backgroundColor: "#3DDC84" }}
          className="confirm"
          id="saveCategory"
          onClick={handleSave}
        >
          Save
        </button>
      </div>
    </>
  );
};

export default CategorySelector;
